/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import MulticastGroupRoutes from './multicast-group.routes';
import AddMulticastGroupController from './add-multicast-group.controller';
import MulticastGroupDirective from './multicast-group.directive';
import MulticastGroupTableConfig from './multicast-group-table.config';

export default angular.module('tektelic.multicastGroup', [])
    .config(MulticastGroupRoutes)
    .controller('AddMulticastGroupController', AddMulticastGroupController)
    .directive('tkMulticastGroup', MulticastGroupDirective)
    .factory('multicastGroupTableConfig', MulticastGroupTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/multicast-group/index.js